// Javascript implementation of the ruby function toSlug
export function toSlug(value: string): string {
  return value
    .normalize('NFKD') // Normalize to decompose characters (e.g., é → e)
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritical marks
    .replace(/['’]/g, '') // Remove single quotes
    .replace(/\W+/g, ' ') // Replace non-word characters with space
    .trim() // Trim whitespace from start and end
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, '-'); // Replace spaces with dashes
}
